import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './jobs.css';

import Layout from 'components/global/Layout/Layout';
import JobList from 'components/jobs/JobList/JobList';
import JobsNav from '../../components/jobs/JobsNav/JobsNav';
import JobTagManager from '../../components/jobs/JobTagManager/JobTagManager';

class JobsPage extends React.Component {
  render() {
    const { location } = this.props;

    return (
      <Layout hasHeader>
        <div className='JobsPage-root'>
          <div className='JobsPage-left'>
            <JobsNav location={location} />
          </div>
          <div className='JobsPage-right'>
            {
              location.hash === '' || location.hash === '#list' ?
              <JobList search={location.search} /> : null
            }
            {
              location.hash && location.hash !== '#list' ?
              <JobTagManager mode={location.hash.slice(1)} /> : null
            }
          </div>
        </div>
      </Layout>
    );
  }
}

const connectedJobsPage = connect()(JobsPage);

const wrappedJobsPage = firebaseConnect()(connectedJobsPage);

export default wrappedJobsPage;



// WEBPACK FOOTER //
// ./src/routes/jobs/jobs.js